import React from "react";
import Cookies from "universal-cookie";
import Button from "./Button";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import ImageSilentInput from "./ImageSilentInput";
import Utils from "../utils/utils";
import loadDocument from "../services/loadDocument";
import checkTokenService from "../services/checkToken";
import LoadingOverlay from "react-loading-overlay";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";

export default class UploadDocument extends React.Component {
  constructor(props) {
    super(props);
    this.count = 0;
    this.imageSilentInputRef = React.createRef(); // NUOVO: ref per ImageSilentInput
    this.state = {
      message: undefined,
      description: undefined,
      file: undefined,
      alertName: false,
      alertFile: false,
      editorState: EditorState.createEmpty(),
      contentState: null,
      isLoading: false,
      loadingMessage: "Caricamento in corso...",
      uploadProgress: 0, // Nuovo: percentuale di progresso upload
      visible: this.props.show !== false,
      fileName: null,
      fileSize: null,
    };
    // Limite di 80MB per i file
    this.MAX_FILE_SIZE = 80 * 1024 * 1024;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({ visible: this.props.show !== false });
    }
  }

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
  };

  onContentStateChange = (contentState) => {
    this.setState({ contentState });
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <div>
        <div style={container}>
          <div style={mainClass} onClick={(e) => e.stopPropagation()}>
            {this.state.isLoading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  padding: "40px",
                }}
              >
                <LoadingOverlay
                  active={true}
                  styles={{
                    overlay: (base) => ({
                      ...base,
                      background: "rgba(255, 255, 255, 0.95)",
                      position: "static",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }),
                    spinner: (base) => ({
                      ...base,
                      width: "80px",
                      "& svg circle": {
                        stroke: "#c41e3a",
                      },
                    }),
                    content: (base) => ({
                      ...base,
                      position: "static",
                      marginTop: "20px",
                      color: "#333",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }),
                  }}
                  spinner
                  text={this.state.loadingMessage}
                >
                  <div style={{ height: "200px" }} />
                </LoadingOverlay>

                {/* Barra di progresso */}
                <div
                  style={{
                    width: "80%",
                    maxWidth: "400px",
                    marginTop: "20px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "30px",
                      backgroundColor: "#e0e0e0",
                      borderRadius: "15px",
                      overflow: "hidden",
                      position: "relative",
                      boxShadow: "inset 0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div
                      style={{
                        width: `${this.state.uploadProgress}%`,
                        height: "100%",
                        backgroundColor:
                          this.state.uploadProgress === 100
                            ? "#4caf50"
                            : "#c41e3a",
                        transition: "width 0.3s ease-in-out",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "15px",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "14px",
                          textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                        }}
                      >
                        {this.state.uploadProgress}%
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      fontSize: "13px",
                      color: "#666",
                    }}
                  >
                    {this.state.uploadProgress < 95 && "📤 Caricamento file..."}
                    {this.state.uploadProgress >= 95 &&
                      this.state.uploadProgress < 100 &&
                      "⏳ Elaborazione..."}
                    {this.state.uploadProgress === 100 && "✅ Completato!"}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div
                  style={closeBtn}
                  onClick={() => {
                    this.setState({ visible: false });
                    this.props.onClose();
                  }}
                >
                  ❌
                </div>
                <div style={windowTitle}>Nuovo file</div>
                <br />

                <input
                  style={{ ...input, backgroundColor: "#eeeeee" }}
                  type="text"
                  placeholder="Inserisci nome"
                  value={this.state.message}
                  onChange={(value) => {
                    this.setState({
                      message: value.target.value,
                      alertName: false,
                    });
                  }}
                />
                {this.state.alertName && (
                  <div
                    style={{
                      marginTop: 5,
                      borderRadius: 10,
                      width: 300,
                      height: 32,
                      padding: 5,
                      color: "#c41e3a",
                      fontWeight: "bold",
                    }}
                  >
                    <p>❗ Inserisci nome</p>
                  </div>
                )}
                <br />
                <br />

                <div>
                  <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Inserisci testo:
                  </div>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      minHeight: "150px",
                      padding: "5px",
                    }}
                    className="compact-editor"
                  >
                    <Editor
                      editorState={this.state.editorState}
                      onEditorStateChange={this.onEditorStateChange}
                      onContentStateChange={this.onContentStateChange}
                      toolbar={{
                        options: [
                          "inline",
                          "blockType",
                          "list",
                          "textAlign",
                          "link",
                          "history",
                        ],
                        inline: { inDropdown: false },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: { inDropdown: true },
                      }}
                    />
                  </div>
                </div>

                <br />
                <ImageSilentInput
                  ref={this.imageSilentInputRef}
                  name={""}
                  value={this.state.imageToLoad}
                  onChange={async (base64, fileName, fileInfo) => {
                    console.log(
                      "🟢 [uploadDispense] File ricevuto da ImageSilentInput:",
                      {
                        fileName: fileName,
                        fileSize: fileInfo?.size,
                        fileSizeMB: fileInfo
                          ? (fileInfo.size / 1024 / 1024).toFixed(2)
                          : "N/A",
                        base64Length: base64?.length,
                        hasBase64: !!base64,
                      }
                    );

                    // Verifica dimensione file
                    if (fileInfo && fileInfo.size > this.MAX_FILE_SIZE) {
                      console.warn("⚠️ [uploadDispense] File troppo grande:", {
                        size: fileInfo.size,
                        maxSize: this.MAX_FILE_SIZE,
                      });
                      alert(
                        `Il file è troppo grande (${(
                          fileInfo.size /
                          1024 /
                          1024
                        ).toFixed(2)} MB). ` +
                          `La dimensione massima consentita è 80 MB.`
                      );
                      return;
                    }

                    // Mostra un messaggio di attesa per file grandi
                    if (fileInfo && fileInfo.size > 5 * 1024 * 1024) {
                      console.log(
                        "🟡 [uploadDispense] File grande rilevato, aggiornamento stato..."
                      );
                      this.setState({
                        filecontent: base64,
                        alertFile: false,
                        fileName: fileName,
                        fileSize: (fileInfo.size / 1024 / 1024).toFixed(2),
                        loadingMessage: `Caricamento file (${(
                          fileInfo.size /
                          1024 /
                          1024
                        ).toFixed(2)} MB)...`,
                      });
                      console.log(
                        "✅ [uploadDispense] Stato aggiornato per file grande"
                      );
                    } else {
                      console.log(
                        "🟢 [uploadDispense] File normale, aggiornamento stato..."
                      );
                      this.setState({
                        filecontent: base64,
                        alertFile: false,
                        fileName: fileName,
                        fileSize: fileInfo
                          ? (fileInfo.size / 1024 / 1024).toFixed(2)
                          : null,
                      });
                      console.log("✅ [uploadDispense] Stato aggiornato");
                    }
                  }}
                />
                {this.state.alertFile && (
                  <div
                    style={{
                      marginTop: 5,
                      borderRadius: 10,
                      width: 300,
                      height: 32,
                      padding: 5,
                      color: "#c41e3a",
                      fontWeight: "bold",
                    }}
                  >
                    <p>❗ Inserisci file</p>
                  </div>
                )}
                {this.state.filecontent && (
                  <div
                    style={{
                      width: "300px",
                      minHeight: 45,
                      boxShadow: "0px 1px 3px lightgrey",
                      backgroundColor: "#F3F3F3",
                      paddingTop: 5,
                      paddingBottom: 5,
                      paddingLeft: 20,
                      paddingRight: 20,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      borderRadius: 10,
                      cursor: "pointer",
                      marginBottom: 10,
                      marginLeft: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={require("../images/folder.png")}
                          style={{ height: 30, width: 30, marginRight: 15 }}
                          alt="File"
                        />
                        <div style={{ flex: 1 }}>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "darkgrey",
                              margin: 0,
                              textTransform: "none",
                              fontSize: "14px",
                              wordBreak: "break-word",
                            }}
                          >
                            {this.state.fileName || "File"}
                          </p>
                          {this.state.fileSize && (
                            <p
                              style={{
                                fontSize: "12px",
                                color: "#999",
                                margin: "2px 0 0 0",
                              }}
                            >
                              {this.state.fileSize} MB
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <DeleteIcon
                      className="icon"
                      style={{
                        height: "20px",
                        width: "20px",
                        alignSelf: "center",
                        marginLeft: "10px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm("Elimina file?") == false) return;
                        console.log(
                          "🗑️ [uploadDispense] File eliminato dall'anteprima"
                        );

                        // Reset del componente ImageSilentInput
                        if (this.imageSilentInputRef.current) {
                          this.imageSilentInputRef.current.resetFile();
                        }

                        this.setState({
                          filecontent: undefined,
                          fileName: null,
                          fileSize: null,
                        });
                      }}
                    />
                  </div>
                )}

                <br />
                <Button
                  callback={async () => {
                    console.log("🔴 [uploadDispense] Click su pulsante Carica");

                    // Previeni click multipli se sta già caricando
                    if (this.state.isLoading) {
                      console.warn(
                        "⚠️ [uploadDispense] Upload già in corso, ignoro click"
                      );
                      return;
                    }

                    const cookies = new Cookies();
                    const token = cookies.get("token", { path: "/" });
                    const username = cookies.get("username", { path: "/" });
                    const body = draftToHtml(this.state.contentState);
                    let message = this.state.message;
                    let filecontent = this.state.filecontent;
                    let description = this.state.description;
                    const userId = cookies.get("userId", { path: "/" });

                    // Debug: verifica se i valori sono presenti
                    console.log("🔴 [uploadDispense] Dati upload:", {
                      username,
                      token: token ? "presente" : "mancante",
                      userId,
                      message,
                      hasFilecontent: !!filecontent,
                      filecontentLength: filecontent?.length,
                      fileName: this.state.fileName,
                      fileSize: this.state.fileSize,
                    });

                    if (!token || !username) {
                      console.error(
                        "❌ [uploadDispense] Token o username mancante"
                      );
                      alert("Sessione scaduta. Effettua nuovamente il login.");
                      window.location.href = "/";
                      return;
                    }

                    if (message == null || message.trim().length === 0) {
                      console.warn("⚠️ [uploadDispense] Nome mancante");
                      this.setState({ alertName: true });
                    } else if (!filecontent) {
                      console.warn("⚠️ [uploadDispense] File mancante");
                      this.setState({ alertFile: true });
                    } else {
                      // Stima della dimensione del file in base al base64
                      const base64Size = filecontent.length * 0.75; // Stima approssimativa
                      const sizeInMB = base64Size / 1024 / 1024;

                      console.log("🟡 [uploadDispense] Inizio upload:", {
                        sizeInMB: sizeInMB.toFixed(2),
                        isLargeFile: sizeInMB > 5,
                      });

                      // Verifica validità del token prima dell'upload
                      this.setState({
                        isLoading: true,
                        uploadProgress: 0,
                        loadingMessage:
                          sizeInMB > 5
                            ? `Caricamento file grande (${sizeInMB.toFixed(
                                1
                              )} MB)... Attendere prego.`
                            : "Caricamento in corso...",
                      });

                      console.log("🔵 [uploadDispense] Verifica token...");
                      const tokenValid = await checkTokenService(
                        username,
                        token
                      );

                      if (!tokenValid) {
                        console.error("❌ [uploadDispense] Token non valido");
                        this.setState({
                          isLoading: false,
                          uploadProgress: 0,
                        });
                        alert(
                          "Sessione scaduta. Effettua nuovamente il login."
                        );
                        window.location.href = "/";
                        return;
                      }

                      console.log(
                        "✅ [uploadDispense] Token valido, invio al server..."
                      );
                      const uploadStartTime = Date.now();

                      loadDocument(
                        username,
                        token,
                        this.props.corso.id,
                        message,
                        filecontent,
                        body,
                        userId,
                        (progress) => {
                          // Callback per aggiornare il progresso
                          console.log(
                            `📊 [uploadDispense] Progresso: ${progress}%`
                          );
                          this.setState({
                            uploadProgress: progress,
                            loadingMessage:
                              progress < 95
                                ? `Caricamento in corso... ${progress}%`
                                : progress < 100
                                ? "Elaborazione sul server..."
                                : "Completamento...",
                          });
                        }
                      )
                        .then((resp) => {
                          const uploadDuration = (
                            (Date.now() - uploadStartTime) /
                            1000
                          ).toFixed(2);
                          console.log(
                            `✅ [uploadDispense] Upload completato in ${uploadDuration}s:`,
                            resp
                          );

                          this.setState({
                            uploadProgress: 100,
                            isLoading: false,
                            loadingMessage: "Caricamento in corso...",
                          });

                          if (resp && resp.status == "success") {
                            console.log("✅ [uploadDispense] Upload riuscito!");
                            alert(
                              `File caricato con successo!\n\nFile: ${this.state.fileName}\nDimensione: ${this.state.fileSize} MB\nTempo: ${uploadDuration}s`
                            );
                            this.setState({ visible: false });
                            this.props.onClose();
                          } else {
                            console.error(
                              "❌ [uploadDispense] Errore dal server:",
                              resp
                            );
                            const errorMsg =
                              resp?.message ||
                              resp?.error ||
                              "Errore sconosciuto";
                            alert(
                              `❌ Errore nel caricamento del file\n\n${errorMsg}\n\nSe il problema persiste, contatta l'assistenza tecnica.`
                            );
                          }
                        })
                        .catch((error) => {
                          const uploadDuration = (
                            (Date.now() - uploadStartTime) /
                            1000
                          ).toFixed(2);
                          console.error(
                            `❌ [uploadDispense] Errore upload dopo ${uploadDuration}s:`,
                            error
                          );

                          this.setState({
                            uploadProgress: 0,
                            isLoading: false,
                            loadingMessage: "Caricamento in corso...",
                          });

                          // Messaggio di errore specifico in base al tipo di errore
                          let errorMessage = "Errore nel caricamento del file";

                          if (error && error.error === "TIMEOUT") {
                            errorMessage = `⏱️ Timeout superato\n\nIl caricamento ha richiesto troppo tempo.\n\nSuggerimenti:\n• Verifica la connessione internet\n• Riduci la dimensione del file\n• Riprova più tardi`;
                          } else if (error && error.error === "NETWORK_ERROR") {
                            errorMessage = `🌐 Errore di connessione\n\n${error.message ||
                              "Verifica la connessione internet"}\n\nDettagli: ${error.details ||
                              "N/A"}`;
                          } else if (error && error.message) {
                            errorMessage = `❌ ${error.message}\n\n${
                              error.details ? "Dettagli: " + error.details : ""
                            }`;
                          } else if (typeof error === "string") {
                            errorMessage = `❌ ${error}`;
                          }

                          alert(errorMessage);
                        });
                    }
                  }}
                  title={"Carica"}
                ></Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const input = {
  width: "300px",
  padding: "10px",
  borderLeft: 0,
  borderTop: 0,
  borderRight: 0,
  borderBottom: "1px solid darkgrey",
};

const windowTitle = {
  color: "darkgrey",
  fontSize: 30,
  fontWeight: "bold",
  fontFamily: "Teko",
  textAlign: "left",
  marginLeft: 5,
};

const closeBtn = {
  position: "absolute",
  cursor: "pointer",
  right: 10,
  top: 10,
  padding: 10,
  zIndex: 999,
};

const container = {
  position: "fixed",
  display: "block",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  minWidth: "100%",
  minHeight: "100%",
  backgroundColor: "#3C3C3C4D",
  overflowY: "scroll",
  overflowX: "hidden",
  zIndex: 999,
};

const mainClass = {
  paddingBottom: 10,
  position: "absolute",
  left: "calc((100% - 400px)/2",
  top: "100px",
  minWidth: "350px",
  maxHeight: 700,
  minHeight: 350,
  width: "350px",
  background: "white",
  padding: "20px",
  boxShadow: "0px 2px 10px darkgrey",
  borderRadius: "10px",
  bottom: "30px",
  overflowY: "auto",
};
